import * as React from 'react';
import classNames from 'classnames';
import {isPopup} from '../../../_shared/GWTBridge/invoke/netForm';
import styles from '../styles/FieldSearch.module.scss';

function generateStyle(element, windowRelative, isRtl) {
    const inputHeight = element.bottom - element.top;
    const inputWidth = element.right - element.left;
    let position;
    let topPosition;
    const borderWidth = 10;
    if (windowRelative) {
        position = {left: element.left - borderWidth};
        topPosition = {top: element.top - borderWidth};
    } else {
        position = isRtl ? {left: -borderWidth} : {right: -borderWidth};
        topPosition = {top: -borderWidth};
    }

    return {
        width: inputWidth + borderWidth * 2,
        height: inputHeight + borderWidth * 2,
        ...topPosition,
        ...position
    };
}

interface HoveringInputBorderProps {
    isUpword: boolean;
    elementRect: DOMRect | ClientRect;
    windowRelative: boolean;
    isRtl: boolean;
}

export const HoveringInputBorder = (props: HoveringInputBorderProps) => {
    const {isUpword, elementRect, windowRelative, isRtl} = props;
    const borderStyle = generateStyle(elementRect, windowRelative, isRtl);
    return (
        <div
            className={classNames(
                'ignore-react-onclickoutside',
                styles.inputCover,
                styles.inputBorder,
                isUpword && styles.inputBorderUpword,
                {[styles.popupDropdownStyle]: isPopup()}
            )}
            style={borderStyle}
        />
    );
};
